const consts = require('./consts.js');

function escapeXmlCharacters(inputString) {
    return inputString.trim().replace(/&/g, '&amp;')
                      .replace(/</g, '&lt;')
                      .replace(/>/g, '&gt;')
                      .replace(/"/g, '&quot;')
                      .replace(/'/g, '&apos;');
}


function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
        dif = tzo >= 0 ? '+' : '-',
        pad = function(num) {
            return (num < 10 ? '0' : '') + num;
        };
  
    return date.getFullYear() +
        '-' + pad(date.getMonth() + 1) +
        '-' + pad(date.getDate()) +
        'T' + pad(date.getHours()) +
        ':' + pad(date.getMinutes()) +
        ':' + pad(date.getSeconds())
  }

// True for a "YYYY-MM-DD" string naming a real day (no 2024-02-30 rolling over into March)
function isCalendarDate(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return false;
    }
    const date = new Date(`${value}T00:00:00.000Z`);
    return !isNaN(date) && date.toISOString().slice(0, 10) === value;
}

function ExcelDateToJSDate(serial) {     
    if (!serial) {
        return null;
    } 
    var utc_days  = Math.floor(serial - 25569);
    var utc_value = utc_days * 86400;
    var date_info = new Date(utc_value * 1000);
    var fractional_day = serial - Math.floor(serial) + 0.0000001;
    var total_seconds = Math.floor(86400 * fractional_day);
    var seconds = total_seconds % 60;
    total_seconds -= seconds;
    var hours = Math.floor(total_seconds / (60 * 60));
    var minutes = Math.floor(total_seconds / 60) % 60;
 
    return new Date(date_info.getFullYear(), date_info.getMonth(), date_info.getDate(), hours, minutes, seconds);
}
function countryNameFormat(value) {
    if (typeof value !== 'string') {
        return 'Invalid input. Expected a string.';
    }
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
}

const cvsImportFields = {
    'Player Account Id': function(obj) {
        return obj['PlayerId']
    },
    'Gender': function(obj){
        return consts.gender_inverse[obj['Gender']]
    },
    'Last Name': function(obj){
        return obj['LastName']
    },
    'First Name': function(obj){
        return obj['FirstName']
    },
    'Birth Date': function(obj){
        try {
            return obj['DateOfBirth'].toISOString().slice(0,10);
        } catch(error) {
            return null
        }
    },
    'ID Number': function(obj) {
        return obj['TaxNumber']
    },
    'Nationality': function(obj) {
        return consts.iso_to_country[obj['Nationality']]
    },
    'Birthplace': function(obj) {
        if (obj['Birthplace'] && consts.iso_to_country[obj['Birthplace']]) {
            return consts.iso_to_country[obj['Birthplace']]
        }
        return obj['Birthplace'] || 'Unknown'
    },
    'Residence': function(obj) {
        if (obj['ResidenceCountry'] && consts.iso_to_country[obj['ResidenceCountry']]) {
            return consts.iso_to_country[obj['ResidenceCountry']]
        }
        return obj['ResidenceCountry'] || 'Unknown'
    },
    'Passport Number': function(obj) {
        return obj['PassportNumber']
    },
    'Passport Country': function(obj) {
        if (obj['PassportCountry'] && consts.iso_to_country[obj['PassportCountry']]) {
            return consts.iso_to_country[obj['PassportCountry']]
        }
        return obj['PassportCountry'] || 'Unknown'
    },
    'Source of Funds': function(obj) {
        return obj['SourceOfWealth']
    },
    'Address': function(obj) {
        return obj['Address']
    },
    'City': function(obj) {
        return obj['City']
    },
    'Zip': function(obj) {
        return obj['Zip']
    },
    'Country': function(obj) {
        return consts.iso_to_country[obj['Country']]
    },
    'Type' : function(obj) {
        return obj['IndentificationType']
    },
    'Number': function(obj) {
        return obj['IdentificationNumber']
    },
    'Issue Date': function (obj) {
        try {
            return obj['DocumentIssueDate'].toISOString().slice(0,10);
        } catch(error) {
            return null
        }
    },
    'Expiry Date': function (obj) {
        try {
            return obj['DocumentExpiryDate'].toISOString().slice(0,10);
        } catch(error) {
            return null
        }
    },
    'Issue Country': function(obj) {
        if (obj['IdentificationCountry'] && consts.iso_to_country[obj['IdentificationCountry']]) {
            return consts.iso_to_country[obj['IdentificationCountry']]
        }
        return obj['IdentificationCountry']
    },

}



function getValue(obj, key) {
    return cvsImportFields[key] ? cvsImportFields[key](obj) : null;
}

// Template columns that can be filled from imported player data via 'Player Account Id'.
const PLAYER_KEY_COLUMN = 'Player Account Id';
const PLAYER_LINKED_COLUMNS = Object.keys(cvsImportFields).filter(col => col !== PLAYER_KEY_COLUMN);

// Convert a PlayerData record into { 'Template Column': value } for the linked columns.
function playerRecordToColumns(obj) {
    const result = {};
    for (const column of PLAYER_LINKED_COLUMNS) {
        const value = getValue(obj, column);
        if (value !== null && value !== undefined && value !== '') {
            result[column] = value;
        }
    }
    return result;
}


function validateValue({
        key, 
        name, 
        value, 
        errorList, 
        index, 
        skipp_null = false, 
        row = null
    }, include_row = false) {
    try {
        let value_param = value;
        let value_from_validation = null;
        let error = null;
        let fromDatabase = null;
        if (!value_param) {

            if(row.playerDBInfo) {
                const findValue = getValue(row.playerDBInfo, name)
                if (findValue) {
                    value_param = findValue;
                    fromDatabase = true
                } else {
                    if (skipp_null === false) {
                        errorList.push({
                            errorText: `Missing value`,
                            columnName: name,
                            index: index,
                        });
                        return 
                    }
                }
            } else {
                if (skipp_null === false) {
                    errorList.push({
                        errorText: `Missing value`,
                        columnName: name,
                        index: index,
                    });
                    return 

                }
            }
        }

        if (!value_param && skipp_null === true) {
            return { value: value_param};
        }
        else {
            if (typeof value === 'string') { 
                // Raw value: XML escaping happens when the report is rendered (XMLNode), so
                // length checks and the preview see what the user actually typed.
                value_param = value.trim();
            }
            [error, value_from_validation] = validator.validate({
                validationKey: key, 
                validationValue: value_param, 
                dataRow: row,
                columnName: name 
            });
            
            if (error) {
                errorList.push({
                    errorText: error,
                    columnName: name,
                    index: index,
                    row: include_row ? row : null
                });
            }
        }

        return { value: value_from_validation || value_param, fromDatabase};
    } catch (Error) {   
        throw Error;
    }
}
function check_length(value, lengthmax, lengthmin) {
    if (value?.length > lengthmax) {
        return `Length of "${value}" is too long`;
    }
    if (value?.length < lengthmin) {
        return `Length of "${value}" is too short`;
    }
}

// Date formats a player-import file may use. The user picks one on the mapping screen;
// the same parser runs in the browser (validation) and on the server (import job).
// An optional trailing time ("01/08/2019 00:00", "2019-08-01 13:45:10") is ignored.
const CSV_DATE_FORMATS = {
    'yyyy-mm-dd': { label: 'yyyy-mm-dd (2019-08-31)', validatorKey: 'csv_date', regex: /^(\d{4})[-/.](\d{1,2})[-/.](\d{1,2})$/, order: ['y', 'm', 'd'] },
    'dd/mm/yyyy': { label: 'dd/mm/yyyy (31/08/2019)', validatorKey: 'csv_date_dmy', regex: /^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/, order: ['d', 'm', 'y'] },
    'mm/dd/yyyy': { label: 'mm/dd/yyyy (08/31/2019)', validatorKey: 'csv_date_mdy', regex: /^(\d{1,2})[-/.](\d{1,2})[-/.](\d{4})$/, order: ['m', 'd', 'y'] },
};
const DEFAULT_CSV_DATE_FORMAT = 'yyyy-mm-dd';

// Returns the date as 'yyyy-mm-dd', or null if the value doesn't match the format or isn't a real calendar date.
function parseCsvDate(valueSent, format = DEFAULT_CSV_DATE_FORMAT) {
    const spec = CSV_DATE_FORMATS[format];
    if (!spec) return null;
    const value = `${valueSent ?? ''}`.trim().replace(/[ T]\d{1,2}:\d{2}(:\d{2}(\.\d+)?)?\s*(Z|[AaPp][Mm])?$/, '');
    const match = value.match(spec.regex);
    if (!match) return null;
    const parts = {};
    spec.order.forEach((key, i) => { parts[key] = Number(match[i + 1]); });
    const date = new Date(Date.UTC(parts.y, parts.m - 1, parts.d));
    if (date.getUTCFullYear() !== parts.y || date.getUTCMonth() !== parts.m - 1 || date.getUTCDate() !== parts.d) {
        return null; // e.g. 31/02/2019 or month 13
    }
    return date.toISOString().slice(0, 10);
}

function csvDateValidator(format) {
    return function (valueSent, row, columnName) {
        const value = `${valueSent ?? ''}`.trim();
        const parsed = parseCsvDate(value, format);
        if (!parsed) {
            return `${columnName} "${value}" is not a valid date in the format ${format}`;
        }
        return [null, parsed];
    };
}

let validator = {
    rentity_id: function (value) {
        return check_length(value, 255, 1);
    },
    name: function(value) {
        return check_length(value, 255, 1);
    },
    rentity_branch: function (value) {
        if (!value === parseInt(value, 10)) {
            return `Branch "${value}" is not an Integer`;
        }
        return check_length(value, 255, 1);
    },
    currency_code: function (value, row) {
        if (!consts.currencies[value]){
            return `Currency code "${value}" is not valid`;
        }
        if (value === 'ANG'){
            const transactionDate = ExcelDateToJSDate(row['Date']);
            if (transactionDate > new Date('2025-03-31')) {
                return `Currency code "ANG" is not valid after 2025-03-31, use XCG instead`;
            }
        }
    },
    business: function (value) {
        return check_length(value, 255, 1);
    },
    incorporation_number: function (value) {
        return check_length(value, 50, 1);
    },
    tax_number: function (value) {
        // TODO add country based validation
        return check_length(value, 20, 5);
    },
    amount_local: function (value) {
        if (typeof value !== 'number') {
            return 'specified value is not a number'   
        }
        return [null, Math.abs(value).toFixed(2)];
    },
    role: function (value){
        let type = consts.party_role_type[value];
        if (type) {
            return [null, type]
        }
        return 'Type of transaction can be either Outgoing or Incoming';
    },
    transaction_location: function (value) {
        let swiftErrors = this.swift(value);
        if (swiftErrors) {
            return swiftErrors;
        }
        const country_code = value.slice(4, 6)
        if (consts.iso_to_country[country_code]) {
            return [null, countryNameFormat(consts.iso_to_country[country_code])];
        }
        return `"${country_code}" is not valid country code`;
    },
    transmode_code: function (value) {
        let type = consts.transmode_code[value];
        if (!type) {
            return `Transmode code "${value}" is not valid`;
        }
        return [null, type];
    },
    funds_code: function (value) {
        let type = consts.fund_code_type[value];
        if (!type) {
            return `Funds code "${value}" is not valid`;
        }
        return [null, type];
    },
    gender: function (value) {
        let type = consts.gender_vars[value];
        if (!type) {
            return `Gender "${value}" is not valid`;
        }
        return [null, type];
    },
    gender_inverse: function (value) {
        let type = consts.gender_inverse[value];
        if (!type) {
            return `Gender "${value}" is not valid`;
        }
        return [null, type];
    },
    business_type: function (value) {
        return check_length(value, 255, 1);
    },
    legal_form: function (value) {
        let form = consts.legal_form[value];
        if (!form) {
            return `Legal form "${value}" is not valid`;
        }
        return [null, form];
    },
    non_bank_institution: function (value) {
        if (typeof value === 'boolean') {
            return [null, value];
        }
        if (value.toLowerCase() === 'true') {
            return [null, true];
        }
        if (value.toLowerCase() === 'false') {
            return [null, false];
        }
        return `Non Bank Institution field should be either "true" or "false"`;
    },
    identification_type: function (value) {
        let type = consts.identification_types[value];
        if (!type) {
            return `Identification type "${value}" is not valid`;
        }
        return [null, type];
    },
    report_code: function (value) {
        report_type = consts.report_code[value];
        if (!report_type) {
            return `Report code "${value}" is not valid`;
        }
        return [null, report_type];
    },
    js_time: function (value) {
        if (typeof value === 'string') {
            const timeRegex = /^(\d{2}):(\d{2})$/;
            const match = value.match(timeRegex);
            if (!match) {
                return `Time "${value}" is not in the format HH:MM`;
            }
            const hours = parseInt(match[1], 10);
            const minutes = parseInt(match[2], 10);
            if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
                return `Time "${value}" has invalid hours or minutes`;
            }
            return [null, value];
        }
    },
    email: function (value) {
        const emailRegex = /^[_a-zA-Z0-9-+]+(\.[_a-zA-Z0-9-+]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*(\.[a-zA-Z]{2,9})$/;
        if (!emailRegex.test(value)) {
            return `Email "${value}" is not valid`;
        }
    },
    time: function (value) {
        if (typeof value !== 'number') {
            return ['Specified value is not a number', null];
        }
        if (value < 0 || value >= 1) {
            return ['Value is not a valid time (must be 0 ≤ value < 1)', null];
        }
    
        const fractionalDay = value % 1; // just in case value has integer part
        const totalSeconds = Math.round(fractionalDay * 86400);
    
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    
        return [null, formattedTime];
    },
    country: function (value) {
        const check = JSON.parse(JSON.stringify(consts.countries));
        delete check['UNKNOWN']
        if (!check[value]){
            return `Country "${value}" is not in the list`;
        }
        return [null, check[value]];
    },
    country_extended: function (value) {
        if (!consts.countries[value]){
            return `Country "${value}" is not in the list`;
        }
        return [null, consts.countries[value]];
    },
    iso_code: function (value) {
        if (!consts.iso_to_country[value]){
            return `ISO code "${value}" is not a valid country code`;
        }
        return [null, consts.iso_to_country[value]];
    },
    institution_name: function (value) { 
        return check_length(value, 255, 1);
    },
    indicator: function (value, row, columnName) {
        if (!row['Indicators'] && !row['Indicators2'] && columnName == 'Indicators') {
            return `At least one Indicator should be specified.`;
        }
        if (row['Indicators'] && row['Indicators2'] && row['Indicators'] === row['Indicators2'] && columnName == 'Indicators2') {
            return 'Duplicate indicators provided';
        }
        if (value){
            return consts.indicators.includes(value) ? '' : `Indicator "${value}" is not valid`;
        }
    },
    reason: function (value) {
        return check_length(value, 4000, 1);
    },
    account: function (value) {
        return check_length(value, 50, 1);
    },
    swift: function (value, row, columnName) {
        const swiftRegex = /^[A-Z]{4}[A-Z]{2}[0-9A-Z]{2}([0-9A-Z]{3})?$/;
        result = swiftRegex.test(value);
        if (result) {
            const country_code = value.slice(4, 6);
            if (!consts.iso_to_country[country_code]) {
                return `"${country_code}" is not valid country code for swift ${value}`;
            }
        } else {
            return `Invalid SWIFT code: "${value}"`;
        }
    },
    account_name: function (value) {
        return check_length(value, 255, 1);
    },
    foreign_exchange_rate: function (value) {
        if (typeof value === 'number') {
            return [null, value.toFixed(2)];
        }
        return 'Specified value is not a number';
    },
    foreign_amount: function (value) {
        if (typeof value === 'number') {
            return [null, Math.abs(value).toFixed(2)];
        }
        return 'Specified value is not a number';
    },
    nr: function (value) {
        return check_length(value, 50, 1);
    },
    transactionnumber: function (value) {
        return check_length(value, 50, 1);
    },
    internal_ref_number: function (value) {
        return check_length(value, 50, 1);
    },
    js_date: function (value) {
        // Excel date cells arrive as YYYY-MM-DD (see loadData); anything else - "1231", "01/02/2024",
        // "2024-02-30" - would end up as an invalid dateTime in the XML, so it is rejected here.
        if (!isCalendarDate(value)) {
            return `"${value}" is not a valid Date, use the YYYY-MM-DD format`;
        }
        return [null, `${value}T00:00:00`];  
    },
    excel_date: function (value) {
        let date = null
        if (typeof value == 'number') {
            if (value < 10000 || value > 9999999999) {
                return 'Issue processing date';
            }
            date = ExcelDateToJSDate(value);
        }
        else {
            if (date == 'Invalid Date' || !date) {
                return `Date "${value}" is not valid`;
            }
        }
        return [null, toIsoString(date).slice(0,19)];
    },
    transaction_description: function (value) {
        return check_length(value, 4000, 1);

    },
    zip: function (value) {
        if (value){
            const regex = /^[\p{L}0-9\s.,\-\/#]+$/u;
            if (!regex.test(value)) {
                return `Zip "${value}" contains invalid characters`;
            }
            return check_length(value, 11, 1);
        }
    },
    address_type: function (value) {
        if (!consts.address_types[value]){
            return `Address type "${value}" is not valid`;
        }
        return [null, consts.address_types[value]]
    },
    address: function (value) {
        return check_length(value, 100, 1);
    },
    city: function (value) {
        const regex = /^[\p{L}0-9\s.,\-\/#]+$/u;
        if (!regex.test(value)) {
            return `City "${value}" contains invalid characters`;
        }
        return check_length(value, 255, 1);
    },
    status_code: function (value) {
        if (!consts.status_code[value]){
            return `Status Code "${value}" is not valid`;
        }
        return [null, consts.status_code[value]]
    },
    account_type: function (value) {
        if (!consts.account_types[value]){
            return `Account type "${value}" is not valid`;
        }
        return [null, consts.account_types[value]]
    },
    player_id: function (value) {
        return check_length(value, 255, 1);
    },
    transfer_type: function (value) {
        if (!consts.transfer_type[value]){
            return `Transfer type "${value}" is not valid`;
        }
        return [null, consts.transfer_type[value]]
    },
    first_name: function (valueSent) {
        const value = (valueSent || '').trim();
        const regex = /^[\p{L}]+([ '-][\p{L}]+)*$/u;
        if (!regex.test(value)) {
            return `First name "${value}" contains invalid characters`;
        }
        return check_length(value, 55, 1);
    },
    last_name: function (valueSent) {
        const value = (valueSent || '').trim();
        const regex = /^[\p{L}]+([ '-][\p{L}]+)*$/u;
        if (!regex.test(value)) {
            return `Last name "${value}" contains invalid characters`;
        }
        return check_length(value, 55, 1);
    },
   
    csv_date: csvDateValidator('yyyy-mm-dd'),
    csv_date_dmy: csvDateValidator('dd/mm/yyyy'),
    csv_date_mdy: csvDateValidator('mm/dd/yyyy'),
    identification_type: function (valueSent) {
        if (valueSent === null || valueSent === undefined) {
            return 'Identification type is required';
        }
        const value = valueSent.trim();

        let type = consts.identification_types[value];
        if (!type) {
            return `Identification type "${value}" is not valid`;
        }
        return [null, type];
    },
    scenario: function (value) {
        let type = consts.transaction_direction[value];
        if (!type) {
            return `Scenario "${value}" is not valid`;
        }
        return [null, type];
    },
    identification_number: function (valueSent) {
        return check_length(valueSent, 40, 5);
    },
    source_of_wealth: function (value) {
        return check_length(value, 255, 1);
    },
    validate({validationKey, validationValue, dataRow, columnName}) {
        try {
            let response = this[validationKey](validationValue, dataRow, columnName);
            if (typeof response !== 'object') {
                return [response, null];
            }
            return response;
        }
        catch (error) {
            throw error;
        }
    }
}

module.exports = {
    validateValue,
    escapeXmlCharacters,
    validator,
    CSV_DATE_FORMATS,
    DEFAULT_CSV_DATE_FORMAT,
    parseCsvDate,
    countryNameFormat,
    PLAYER_KEY_COLUMN,
    PLAYER_LINKED_COLUMNS,
    playerRecordToColumns,
};